/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useState } from "react";
import * as API from "../../http/api";
import { useHistory } from "react-router-dom";
import { closelightbox, openlightbox } from "../../util/Functions";
import { Grid, TextField, Button, DialogActions, DialogContent, Dialog, DialogTitle, IconButton, MenuItem } from "@mui/material";
import { ModalStyle } from "../../util/Styles";
import { Close } from "@mui/icons-material";
import { Factor } from ".";

const CardCancel = (props) => {
	const [zPos, setZPos] = useState(45)
  const [reason, setReason] = useState(-1);
  const [comment, setComment] = useState("");
  const [reasonDesc, setReasonDesc] = useState("");
  const [disabled, setDisabled] = useState(true);
  const history = useHistory();

  const onSelectReason = (e) => {
    let value = e.target.value;
    setReason(Number(value));

    let desc = "";
    let cats = props.content.catalog;
    for (let i = 0; i < cats.length; i++) {
      if (cats[i]["k"] == e.target.value) {
        desc = cats[i]["v"];
      }
    }
    setReasonDesc(desc);
    if (e.target.value > 0) {setDisabled(false)} else {setDisabled(true)}
  };

  const send = async () => {
    if (reason === -1) {
      return;
    }
    props.changeLoader(true);
		setZPos(-1)

    let data = {
      cardUuid: props.content.cardUuid,
      spaceUuid: props.content.spaceUuid,
      provider: props.content.partner,
      reason: reason,
      customerUuid: props.customerUuid,
      comment: comment,
      reasonDesc: reasonDesc,
    };

    let request = await API.service( "cardCancel", data, props.pos, props.changeAlert, props.changeLoader, history );
    if ( request.status == 200 && request.data.data.response == "OK" && request.data.data.content) {
      closelightbox();
      if ( request.data.data.content.type == "2FA" || request.data.data.content.type == "1FA" ) {
        let factors = localStorage.factors ? JSON.parse(localStorage.factors) : {};
        factors[props.content.customerUuid] = request.data.data.content.uuid_factor;
        localStorage.factors = JSON.stringify(factors);
      }
      const as = (
        <Factor
          intent="cardCancel"
          contentModal={request.data.data.content}
          pos={props.pos}
          changeAlert={props.changeAlert}
          changeLoader={props.changeLoader}
          history={history}
          key="factor"
        />
      );
      openlightbox(as);
    }

    if ( request.status == 200 && request.data.data.response == "OK" && !request.data.data.content ) {
      await props.changeReload();
      props.changeAlert(true, "success", "Tarjeta cancelada con éxito");
      closelightbox();
    }
    props.changeLoader(false);
		setZPos(45)
  };

  const changeValue = (e) => {
    setComment(e.target.value);
  };

  return (
		<Dialog open={true} sx={{zIndex: zPos, filter: zPos !== 45 ? 'blur(2px)': "none" }} fullWidth>
			<ModalStyle property={String(disabled)}>
				<DialogTitle>
					Cancelar Tarjeta N°: {props.content.pan}
					<IconButton id="headButton" onClick={closelightbox}><Close/></IconButton>
				</DialogTitle>
				
				<DialogContent>
					<Grid container spacing={2} sx={{ marginTop: "10px" }}>
						<Grid item xs={6}>
							<TextField label="Motivo" value={reason}	onChange={onSelectReason.bind(this)} select	size="small" fullWidth >
									<MenuItem value="-1" >Selecione</MenuItem>
								{props.content?.catalog?.map((item, index) => (
									<MenuItem key={`cancel-option-${index}`} value={item.k}>{item.v}</MenuItem>
								))}
							</TextField>
						</Grid>
						<Grid item xs={6}>
							<TextField label="Comentarios" value={comment} onChange={changeValue.bind(this)} size="small" fullWidth />
						</Grid>
					</Grid>
				</DialogContent>
				<DialogActions>					
					<Button disabled={disabled} variant="contained" onClick={send} >Aceptar</Button>
				</DialogActions>
			</ModalStyle>
		</Dialog>
  );
};

export default CardCancel;
